import React from 'react';

function Title(title) {
	return <h1 className=''>{title}</h1>;
}

export default Title;
